import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/tenant-admin/')({
  beforeLoad: () => {
    throw redirect({ to: '/tenant-admin/overview' });
  },
});
